import { Link } from 'react-router-dom'
import './Footer.scss'

export default function Footer() {
  return (
    <>
      <footer className="footer">
        <div className="footer-brand">
          <Link to="/" className="nav-logo footer-logo">
            miss <span>Lem●n</span>
          </Link>
          <p>
            Lumânări și arome artizanale din ceară naturală de soia, cu flori
            uscate. Fabricate cu dragoste în România de Miss Lemon.
          </p>
        </div>

        <div className="footer-col">
          <h4>Produse</h4>
          <Link to="/shop">Sachete Florale</Link>
          <Link to="/shop">Wax Melts</Link>
          <Link to="/shop">Seturi Cadou</Link>
          <Link to="/shop">Noutăți</Link>
        </div>

        <div className="footer-col">
          <h4>Info</h4>
          <a href="/#despre">Despre noi</a>
          <Link to="/shop">Livrare</Link>
          <Link to="/shop">Returnare</Link>
          <Link to="/shop">FAQ</Link>
        </div>

        <div className="footer-col">
          <h4>Contact</h4>
          <a href="https://instagram.com/misslemon" target="_blank" rel="noopener noreferrer">Instagram</a>
          <a href="https://facebook.com/misslemon" target="_blank" rel="noopener noreferrer">Facebook</a>
          <a href="mailto:contact@misslemon.ro">contact@misslemon.ro</a>
        </div>
      </footer>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Miss Lemon Candles. Toate drepturile rezervate.</span>
        <span>Fabricat cu ♥ în România</span>
      </div>
    </>
  )
}
